// extracted by mini-css-extract-plugin
module.exports = {"praxia":"styles_praxia__OHqeI","praxiaEnviroment":"styles_praxiaEnviroment__R3b-y"};